module.exports = __webpack_public_path__ + "static/media/logo.16d219b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 1090
// module chunks = 0